import { mapState, mapActions } from 'pinia';
import { usePageStore, useUserStore } from '@/store';
import util from '../../common/util';
import vForm from '../v-form.vue';
import vInput from '../v-input.vue';
import { loginOrRegister } from './socialstudio-lead-tag.js';
import popMgr from '@/components/global/popMgr';
import agentLeadDialog from './agent-lead-dialog.vue'

export default {
    //  from popMgr How to control the pop-up window 
    i18next: {
        ns: 'common'
    },
    inject: ['destroy'],
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        changeType: Function
    },
    data: function() {
        return {
            loginErrorShow: false,
            loginErrorMsg: '',
            viewClass: 'icon-password',
            passwordType: 'password'
        };
    },
    computed: {
        ...mapState(usePageStore, ['page']),
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        loginTitle() {
            if (this.options.loginTitle === undefined) {
                return this.$t('login.loginTitle');
            } else {
                return this.options.loginTitle;
            }
        },
        loginSubTitle() {
            if (this.options.loginSubtitle === undefined) {
                return this.$t('login.loginSubTitle');
            } else {
                return this.options.loginSubtitle;
            }
        },
        footerHtml() {
            return this.options.agreementHtml && !this.wordPressSSR
                ? this.options.agreementHtml
                : '';
        }
    },
    methods: {
        ...mapActions(useUserStore, ['login']),
        ...mapActions(usePageStore, ['updateSocialTagType']),
        changePasswordType() {
            if (this.passwordType === 'password') {
                this.passwordType = 'text';
                this.viewClass = 'icon-view-active';
            } else {
                this.passwordType = 'password';
                this.viewClass = 'icon-password';
            }
            this.$refs.password.$el.querySelector('input').focus();
        },
        showError(msg) {
            this.loginErrorShow = true;
            this.loginErrorMsg = msg;
            util.timeout({
                handler: () => {
                    this.loginErrorShow = false;
                    this.loginErrorMsg = '';
                },
                delay: 3000,
                unique: true
            });
        },
        onLoginFail(error) {
            if (!error.error) {
                this.showError(error.errorInfo || this.$t('login.loginError'));
            }
        },
        onLoginSucess(user) {
            if (
                util.call(this.options.onLogin, null, user) !== false &&
                this.options.isLoginToast
            ) {
                util.toast(
                    this.options.loginToast || this.$t('login.loginSucceed')
                );
            }
            this.updateSocialTagType(loginOrRegister.login);
            //  pass socialstudio users who click in ， Requires marking when logging in 
            // setLeadTag(
            //     loginOrRegister.login,
            //     user?.id || '',
            //     user?.teamId || ''
            // );z
            //  close the popup 
            this.destroy();
            util.call(this.options.onsuccess);
        },
        doLogin(data) {
            return this.axiosIns
                .post('/api-site/login', data)
                .then(res => {
                    const resData = res.data;
                    const user = resData.user;
                    if (resData.agentLead) {
                        popMgr.create(agentLeadDialog);
                        return;
                    }
                    if (resData.leadAccid && resData.leadToken) {
                        user.leadAccid = resData.leadAccid;
                        user.leadToken = resData.leadToken;
                    }
                    this.login({ user });
                    this.$EventBus.$emit('siteTrack', {
                        ...data,
                        trackType: 'login',
                        ele: this.$el
                    });
                    if (this.wordPressSSR) {
                        this.setCookies(resData['0']);
                    }
                    this.onLoginSucess(user);
                })
                .catch(error => {
                    console.error(error)
                    this.$EventBus.$emit('siteTrack', {
                        errorData: error,
                        trackType: 'login-fail',
                        ele: this.$el
                    });
                    this.onLoginFail(error);
                    this.submitDisabled = false;
                });
        },
        setCookies(cookies) {
            console.warn('set cookies');
            for (let key in cookies) {
                console.log('set' + key + '=' + cookies[key]);
                util.setCookie(key, cookies[key], 30);
            }
        },
        loginSubmit(form) {
            //todo submit track
        },
        loginSubmitSuccess(data) {
            if (this.disclaimerSubmitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            return util
                .addScript(
                    'https://static.chimeroi.com/servicetool-temp/site-cdn/md5.min.js',
                    true
                )
                .then(() => {
                    data.keep = true;
                    data.password = window.md5(data.password);
                    return this.doLogin(data);
                });
        },
        loginSumbitError(errorInfo) {
            //todo error track
        }
    },
    components: {
        'v-form': vForm,
        'v-input': vInput
    }
};
